import { useSelector } from 'react-redux';
import { ModuleConfig, RouteGroup } from 'framework/components/navigation/Navigation.interfaces';
import { selectProfile, selectIsLoadingUser, selectAccessToken, ensureClaims } from 'framework/authorization';
import appModules from 'framework/modules';
import { TOKEN_NOT_FOUND } from 'framework/authorization/Authorization.Selectors';
import { useState, useEffect } from 'react';
import { AppFeatures } from 'stores/features/types';
import { resolvePageGroups } from 'framework/utils/navigationUtils';

export const useNavigation = (featuresState: AppFeatures) => {
  const [modules, setModules] = useState<ModuleConfig[]>([]);

  const profile: any = useSelector(selectProfile);
  const isLoadingUser = useSelector(selectIsLoadingUser);
  const access_token = useSelector(selectAccessToken);

  const filterAuthorizedModules = (module: ModuleConfig) =>
    ((module.pageGroups as RouteGroup[]) ?? []).some((gr) =>
      gr.routes.some((r) => !r.authClaim || ensureClaims(r.authClaim))
    );

  const getAuthorizedModules = async () => {
    const hasFullAccess = profile.fullaccess || profile.poweruser;
    const allAppModules: ModuleConfig[] = await appModules();

    if (hasFullAccess) {
      return allAppModules;
    }
    return (await Promise.all(allAppModules.map(resolvePageGroups))).filter(filterAuthorizedModules);
  };

  useEffect(() => {
    const canFetch = !!access_token && access_token !== TOKEN_NOT_FOUND && !isLoadingUser;
    if (canFetch) {
      getAuthorizedModules().then((res) => setModules(res));
    }
  }, [isLoadingUser, access_token, featuresState?.isLoading]);
  return {
    authorisedModules: modules,
  };
};
